import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'

const pains = [
  {
    pain: 'You spend time every week juggling the agenda - assigning every role by hand and cajoling volunteers',
    benefit:
      'Members claim open roles themselves - and auto-assign fills whatever’s left, fairly rotating everyone through each role',
  },
  {
    pain: 'One Tuesday dropout means a group chat full of “can anyone take Timer?”',
    benefit:
      'Members swap roles themselves, and the live agenda updates the moment they do',
  },
  {
    pain: 'Every meeting starts with rebuilding the same agenda from scratch',
    benefit:
      'Set your cadence once - every upcoming meeting appears on the schedule, ready to fill',
  },
  {
    pain: '“Wait, what am I doing this week?” - asked five times, every week',
    benefit:
      'One live schedule everyone can check from their phone. No account needed to look',
  },
]

export default function LandingPains() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-600">
            Sound familiar?
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Running the club shouldn&apos;t feel like a second job
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Volunteer officers lose evenings to the same avoidable busywork.
            Meeting time gets spent filling roles instead of practicing public
            speaking. Here&apos;s what changes when the schedule runs itself
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2">
            {pains.map((item) => (
              <div
                key={item.pain}
                className="rounded-2xl bg-gray-50 p-6 shadow-sm ring-1 ring-gray-200">
                <dt className="flex gap-x-3 text-base font-semibold leading-7 text-gray-900">
                  <XMarkIcon
                    className="mt-1 h-5 w-5 flex-none text-red-500"
                    aria-hidden="true"
                  />
                  {item.pain}
                </dt>
                <dd className="mt-3 flex gap-x-3 text-base leading-7 text-gray-600">
                  <CheckIcon
                    className="mt-1 h-5 w-5 flex-none text-indigo-600"
                    aria-hidden="true"
                  />
                  {item.benefit}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
